import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './UnauthorizedPage.css';

interface LocationState {
  from?: Location;
  requiredRole?: string;
}

const UnauthorizedPage: React.FC = () => {
  const location = useLocation();
  const state = location.state as LocationState;
  const requiredRole = state?.requiredRole || 'unknown';
  const fromPath = state?.from?.pathname || '/';

  return (
    <div className="unauthorized-page">
      <div className="unauthorized-container">
        <div className="unauthorized-icon">
          <svg
            width="64"
            height="64"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
              fill="#dc3545"
            />
          </svg>
        </div>

        <h1 className="unauthorized-title">Access Denied</h1>

        <p className="unauthorized-message">
          You don't have permission to access this page.
          {requiredRole !== 'unknown' && (
            <span>
              {' '}
              This page requires <strong>{requiredRole}</strong> role access.
            </span>
          )}
        </p>

        <div className="unauthorized-actions">
          <Link to="/" className="btn btn-primary">
            Go to Home
          </Link>

          <Link to="/login" className="btn btn-secondary">
            Login with Different Account
          </Link>

          {fromPath !== '/' && (
            <button
              onClick={() => window.history.back()}
              className="btn btn-outline"
            >
              Go Back
            </button>
          )}
        </div>

        <div className="unauthorized-help">
          <p>
            If you believe this is an error, please contact your administrator
            or <Link to="/support">get help</Link>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
